import { useNoomTogether } from "src/hooks/redux";
import i18n from "src/locales";

export function isMultiUserPlan(planId?: string) {
  return !!planId?.endsWith("__multi");
}

/**
 * TODO (Mladen): Remove after ExR165 is over and not a win!
 */
export function useFamilyMemberName() {
  const { familyMemberName } = useNoomTogether();
  return (
    familyMemberName ||
    i18n.t("price-breakdown:multiUserPlan:defaultFamilyMemberName")
  );
}
